async function getResponse(link) {
    let response = await fetch(link)
    let content = await response.json()
    const modalTitle = document.querySelector('.product-view .title h4')
    const modalSlider = document.querySelector('.main-product__slider')
    const modalImages = document.querySelector('.product-view-img-preview-slider')
    const modalMainImage = document.querySelector('.product-view-img-slider')
    let mainImageHtml = '<div class="main-product__slider-main js-product-view-img-slider">'
    let prevImageHtml ='<div class="main-product__slider-preview js-product-view-img-preview-slider">'
    let key
    for (const [key, value] of Object.entries(content.product.images)) {
        prevImageHtml +='<div>' +
            '<div class="main-product__slider-preview__box"><img src="'+value.src+'"/></div></div>';
        mainImageHtml +='<div>' +
            '<div class="main-product__slider-main__box" data-media-id="'+value.id+'"><img src="'+value.src+'"/></div></div>';
    }
    mainImageHtml += '</div>'
    prevImageHtml += '</div>';
    //edit html
    modalSlider.innerHTML = prevImageHtml + mainImageHtml

    // init sliders in popup
    $(".js-product-view-img-slider").slick({
        slidesToShow: 1, slidesToScroll: 1,// fade: true,
        dots: false, arrows: false, asNavFor: ".js-product-view-img-preview-slider"
    });
    $(".js-product-view-img-preview-slider").slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        asNavFor: ".js-product-view-img-slider",
        arrows: false,
        dots: false,
        vertical: true,
        focusOnSelect: true
    });
}
const quickViewBtns = document.querySelectorAll('.product-box__img-view')
const quickViewSlider =  document.querySelectorAll('.js-product-img-preview-slider')


$(document).on('click','.product-box__img-view',function (e){
    e.preventDefault();
    let checkedElement = e.target.closest('.product-box__actions-list');
    let productCardWrapper = e.target.closest('.product-box');

    let productCardCompareWrapper = productCardWrapper.querySelector('.js-compare-wrapper');
    let productCardCompareElement = productCardWrapper.querySelector('.js-compare-element');


    setTimeout(function() {

        if (productCardCompareElement.classList.contains('in-comparison')) {

            let modal = document.querySelector('.modal');
            let modalCompareItem = modal.querySelector('.js-compare-wrapper');


            var simulateClick = function (elem) {
                // Create our event (with options)
                var evt = new MouseEvent('click', {
                    bubbles: true,
                    cancelable: true,
                    view: window
                });
                // If cancelled, don't dispatch our event
                var canceled = !elem.dispatchEvent(evt);
            };

            if ( !modalCompareItem.querySelector('.js-compare-element').classList.contains('in-comparison') ) {

                simulateClick(modalCompareItem);
            }


        } else {
            //   	let modal = document.querySelector('.modal');
            //     let modalCompareItem = modal.querySelector('.js-compare-wrapper');
            //
            //       console.log(modalCompareItem);
            //
            //       var simulateClick = function (elem) {
            //           // Create our event (with options)
            //           var evt = new MouseEvent('click', {
            //               bubbles: true,
            //               cancelable: true,
            //               view: window
            //           });
            //           // If cancelled, don't dispatch our event
            //           var canceled = !elem.dispatchEvent(evt);
            //       };
            //
            //       if ( modalCompareItem.querySelector('.js-compare-element').classList.contains('in-comparison') ) {
            //
            //            simulateClick(modalCompareItem);
            // }

        }
    }, 2000)


	let product_url = e.target.closest(".product-box").href.split('?variant');
    const productJSON = product_url[0] + '.json'
    quickViewSlider.forEach((slider) => {
        slider.resize()
    })
    getResponse(productJSON)
    let productLink = e.target.closest(".product-box").href
    if(productLink.includes('?variant=')){
        let splitLink = productLink.split('?variant=');
        productLink=splitLink[0];
    }
    $(document).find($('.product-view .product-view__body')).addClass('loading');
    $.get(productLink, function(data) {
        let customActions = $(data).find('.main-product__actions.js-proudct-actions-block')
        let customActionsCompareWrapper = customActions.find('.js-compare-wrapper');
        let customActionsCompareElement = customActions.find('.js-compare-element');




        const productInfo = $(data).find(".main-product__inner .main-product__info-desk")
        const popupProductInfo = $(".product-view .main-product__info-desk")
        const popupProductCharacteristics = $('.product-view .main-product__characteristics')
        const productCharacteristics = $(data).find(".main-product__inner .main-product__characteristics")
        const popupProductPrice = $('.product-view .main-product__buy-head')
        const productPrice = $(data).find(".main-product__inner .main-product__buy-head")
        const popupProductLink = $('.product-view .js-modal-btn')
        const productStatus = $(data).find('.main-product__inner .main-product__status-wrapper')
        const popupProductStatus = $('.product-view .main-product__status-wrapper')
        const productShipping = $(data).find('.main-product__inner .main-product__shipping')
        const popupProductShipping = $('.product-view .main-product__shipping')
        const productOverview = $(data).find('.main-product__inner .main-product__overview')
        const popupProductOverview = $('.product-view .main-product__overview')
        const productForm = $(data).find('.product-addToCart.modal product-form.product-addToCart__btn')
        productForm.removeClass('hidden');
        const popupProductForm = $('.product-view .product-addToCart__btn')
        const productCount = $(data).find('.main-product__inner .js-counter')
        const popupProductCount = $('.product-view .js-counter')
        popupProductCount.replaceWith(productCount)
        popupProductForm.replaceWith(productForm)
        popupProductCharacteristics.replaceWith(productCharacteristics)
        popupProductShipping.replaceWith(productShipping)
        popupProductOverview.replaceWith(productOverview)
        popupProductInfo.replaceWith(productInfo)
        popupProductStatus.replaceWith(productStatus)
        popupProductPrice.replaceWith(productPrice)
        if($('.product-view').find($('product-form .btn'))[0].classList.contains('in-stock')){
            $('.product-view').find($('product-form .btn')).removeAttr("disabled");
        }
        popupProductLink.attr('href', productLink)
        $(document).find($('.product-view .product-view__body')).removeClass('loading');
        $(".js-counter").on("click", function (e) {
            e.preventDefault();
            var $target = $(e.target);
            var $parent = $target.closest(".counter");
            var $counter = $parent.find("[data-context='counter']");
            var $minus = $parent.find("[data-context='minus']");
            var $counterValue = $counter.html().trim();
            var $targetData = $target.data("context");
            if (!$targetData) {
                $targetData = $target.parent().data("context")
            }
            if ($targetData == "minus") {
                if (Number($counterValue) > 1) {
                    $counter.html("" + (Number($counterValue) - 1));
                    if ($counterValue - 1 <= 1) {
                        $minus.addClass("disable")
                    }
                }
            } else if ($targetData == "plus") {
                $counter.html("" + (Number($counterValue) + 1));
                if ($counterValue + 1 >= 1 && $minus.hasClass("disable")) {
                    $minus.removeClass("disable")
                }
            }
        });
        $('.counter-item').on("click", function () {
            let _this = $(this)
            setTimeout(function () {
                console.log(_this.closest(".js-counter").find($('.counter-number')).val())
                productForm.find($('input[name="quantity"]')).val(_this.closest(".js-counter").find($('.counter-number')).val());
            }, 300)
        });
        $('.counter-item').on("change", function () {
            let _this = $(this)
            console.log(_this.closest(".js-counter").find($('.counter-number')).val())
            productForm.find($('input[name="quantity"]')).val(_this.closest(".js-counter").find($('.counter-number')).val());
        });
        $(".js-product-overview-box-btn").on("click", function (e) {
            e.preventDefault();
            var $this = $(this);
            var $parent = $this.closest(".js-product-overview-box");
            if ($parent.hasClass("active")) {
                $parent.removeClass("active")
            } else {
                $parent.addClass("active")
            }
            ProductSliderPosition()
        });
        $('.product-view__info').find($('.main-product__characteristics')).find($('.js-product-characteristics-select')).each(function (){
            let _this=$(this);
            var $parent = _this.closest(".sort");
            var $sortModalBody = $parent.find(".sort-modal__body");
            var $sortBtn = $parent.find(".sort-btn");
            _this.select2({width:"100%",minimumResultsForSearch:-1,templateResult: selectTemplateResult,templateSelection: selectTemplateSelection,dropdownParent: $sortModalBody});
            function selectTemplateSelection(opt) {
                var result = "\n\t\t\t<div class=\"sort-product__characteristics__result\">\n\t\t\t\t<span class=\"sort-product__characteristics__result-placeholder\">\n\t\t\t\t\t" + _this.attr("data-placeholder") + "\n\t\t\t\t</span>\t\n\t\t\t\t<span class=\"sort-product__characteristics__result-value\">\n\t\t\t\t\t" + opt.text + "\n\t\t\t\t</span>\n\t\t\t</div>\n\t\t";
                $sortBtn.html(result);
                return $(result)
            }
            $(document).on("select2:close",_this, function (e) {
                $parent.removeClass("active")
            });
            $(document).on("click",'.sort-btn', function (e) {
                e.preventDefault();
                $(this).closest(".sort").find($('.sort-block')).find($('.js-product-characteristics-select')).select2("open");
                $(this).closest(".sort").addClass("active")
            })
            $(document).on("click",'.sort-modal__close', function (e) {
                e.preventDefault();
                $(this).closest(".sort").find($('.sort-block')).find($('.js-product-characteristics-select')).select2("close");
            })
        })
        function selectTemplateResult(opt) {
            if (!opt.id) {
                return opt.text
            }
            var optImage = $(opt.element).data("img");
            if (!optImage) {
                var $opt = $("<div class=\"select2-results__option-custom \">\n\t\t\t\t\t\t<span>" + opt.text + "</span>\n\t\t\t\t\t</div>");
                return $opt
            } else {
                var _$opt = $("<div class=\"select2-results__option-custom select2-results__option__multi-img\">\n\t\t\t\t\t<img src=\"" + optImage + "\" />\n\t\t\t\t\t<span>" + $(opt.element).text() + "</span>\n\t\t\t\t</div>");
                return _$opt
            }
        }
    });
    let variantBlock = $('variant-selects');
    $(document).on("change","variant-selects select.js-product-characteristics-select.js-options",function (){
        console.log(getCurentVariant());
        $(document).find($('.product-view .product-view__body')).addClass('loading');
        $.get(productLink + '?variant=' + getCurentVariant().id, function(data) {
            const productInfo = $(data).find(".main-product__inner .main-product__info-desk")
            const popupProductInfo = $(".product-view .main-product__info-desk")
            const popupProductCharacteristics = $('.product-view .main-product__characteristics')
            const productCharacteristics = $(data).find(".main-product__inner .main-product__characteristics")
            const popupProductPrice = $('.product-view .main-product__buy-head')
            const productPrice = $(data).find(".main-product__inner .main-product__buy-head")
            const popupProductLink = $('.product-view .js-modal-btn')
            const productStatus = $(data).find('.main-product__inner .main-product__status-wrapper')
            const popupProductStatus = $('.product-view .main-product__status-wrapper')
            const productShipping = $(data).find('.main-product__inner .main-product__shipping')
            const popupProductShipping = $('.product-view .main-product__shipping')
            const productOverview = $(data).find('.main-product__inner .main-product__overview')
            const popupProductOverview = $('.product-view .main-product__overview')
            const productForm = $(data).find('.product-addToCart.modal product-form.product-addToCart__btn')
            productForm.removeClass('hidden');
            const popupProductForm = $('.product-view .product-addToCart__btn')
            popupProductForm.replaceWith(productForm)
            popupProductCharacteristics.replaceWith(productCharacteristics)
            popupProductShipping.replaceWith(productShipping)
            popupProductOverview.replaceWith(productOverview)
            popupProductInfo.replaceWith(productInfo)
            popupProductStatus.replaceWith(productStatus)
            popupProductPrice.replaceWith(productPrice)
            $('.counter-item').on("click", function () {
                let _this = $(this)
                setTimeout(function () {
                    productForm.find($('input[name="quantity"]')).val(_this.closest(".js-counter").find($('.counter-number'))[0].innerText);
                }, 300)
            });
            if($('.product-view').find($('product-form .btn'))[0].classList.contains('in-stock')){
                $('.product-view').find($('product-form .btn')).removeAttr("disabled");
            }
            $(document).find($('.product-view .product-view__body')).removeClass('loading');
            $('.product-view__info').find($('.main-product__characteristics')).find($('.js-product-characteristics-select')).each(function (){
                let _this=$(this);
                var $parent = _this.closest(".sort");
                var $sortModalBody = $parent.find(".sort-modal__body");
                var $sortBtn = $parent.find(".sort-btn");
                _this.select2({width:"100%",minimumResultsForSearch:-1,templateResult: selectTemplateResult,templateSelection: selectTemplateSelection,dropdownParent: $sortModalBody});
                function selectTemplateSelection(opt) {
                    var result = "\n\t\t\t<div class=\"sort-product__characteristics__result\">\n\t\t\t\t<span class=\"sort-product__characteristics__result-placeholder\">\n\t\t\t\t\t" + _this.attr("data-placeholder") + "\n\t\t\t\t</span>\t\n\t\t\t\t<span class=\"sort-product__characteristics__result-value\">\n\t\t\t\t\t" + opt.text + "\n\t\t\t\t</span>\n\t\t\t</div>\n\t\t";
                    $sortBtn.html(result);
                    return $(result)
                }
                $(document).on("select2:close",_this, function (e) {
                    $parent.removeClass("active")
                });
                $(document).on("click",'.sort-btn', function (e) {
                    e.preventDefault();
                    $(this).closest(".sort").find($('.sort-block')).find($('.js-product-characteristics-select')).select2("open");
                    $(this).closest(".sort").addClass("active")
                })
                $(document).on("click",'.sort-modal__close', function (e) {
                    e.preventDefault();
                    $(this).closest(".sort").find($('.sort-block')).find($('.js-product-characteristics-select')).select2("close");
                })
            })
            function selectTemplateResult(opt) {
                if (!opt.id) {
                    return opt.text
                }
                var optImage = $(opt.element).data("img");
                if (!optImage) {
                    var $opt = $("<div class=\"select2-results__option-custom \">\n\t\t\t\t\t\t<span>" + opt.text + "</span>\n\t\t\t\t\t</div>");
                    return $opt
                } else {
                    var _$opt = $("<div class=\"select2-results__option-custom select2-results__option__multi-img\">\n\t\t\t\t\t<img src=\"" + optImage + "\" />\n\t\t\t\t\t<span>" + $(opt.element).text() + "</span>\n\t\t\t\t</div>");
                    return _$opt
                }
            }
            $(".js-product-overview-box-btn").on("click", function (e) {
                e.preventDefault();
                var $this = $(this);
                var $parent = $this.closest(".js-product-overview-box");
                if ($parent.hasClass("active")) {
                    $parent.removeClass("active")
                } else {
                    $parent.addClass("active")
                }
                ProductSliderPosition()
            });
        });
        updateMedia(getCurentVariant());
    });
    $(document).on("change","variant-selects select.js-product-characteristics-select.js-first-option",function (){
        console.log(getCurentVariantForFirstOption())
        $(document).find($('.product-view .product-view__body')).addClass('loading');
        $.get(productLink + '?variant=' + getCurentVariantForFirstOption().id, function(data) {
            const productInfo = $(data).find(".main-product__inner .main-product__info-desk")
            const popupProductInfo = $(".product-view .main-product__info-desk")
            const popupProductCharacteristics = $('.product-view .main-product__characteristics')
            const productCharacteristics = $(data).find(".main-product__inner .main-product__characteristics")
            const popupProductPrice = $('.product-view .main-product__buy-head')
            const productPrice = $(data).find(".main-product__inner .main-product__buy-head")
            const popupProductLink = $('.product-view .js-modal-btn')
            const productStatus = $(data).find('.main-product__inner .main-product__status-wrapper')
            const popupProductStatus = $('.product-view .main-product__status-wrapper')
            const productShipping = $(data).find('.main-product__inner .main-product__shipping')
            const popupProductShipping = $('.product-view .main-product__shipping')
            const productOverview = $(data).find('.main-product__inner .main-product__overview')
            const popupProductOverview = $('.product-view .main-product__overview')
            const productForm = $(data).find('.product-addToCart.modal product-form.product-addToCart__btn')
            productForm.removeClass('hidden');
            const popupProductForm = $('.product-view .product-addToCart__btn')
            popupProductForm.replaceWith(productForm)
            popupProductCharacteristics.replaceWith(productCharacteristics)
            popupProductShipping.replaceWith(productShipping)
            popupProductOverview.replaceWith(productOverview)
            popupProductInfo.replaceWith(productInfo)
            popupProductStatus.replaceWith(productStatus)
            popupProductPrice.replaceWith(productPrice)
            $('.counter-item').on("click", function () {
                let _this = $(this)
                setTimeout(function () {
                    productForm.find($('input[name="quantity"]')).val(_this.closest(".js-counter").find($('.counter-number'))[0].innerText);
                }, 300)
            });
            $(".js-product-overview-box-btn").on("click", function (e) {
                e.preventDefault();
                var $this = $(this);
                var $parent = $this.closest(".js-product-overview-box");
                if ($parent.hasClass("active")) {
                    $parent.removeClass("active")
                } else {
                    $parent.addClass("active")
                }
                ProductSliderPosition()
            });
            if($('.product-view').find($('product-form .btn'))[0].classList.contains('in-stock')){
                $('.product-view').find($('product-form .btn')).removeAttr("disabled");
            }
            $(document).find($('.product-view .product-view__body')).removeClass('loading');
            $('.product-view__info').find($('.main-product__characteristics')).find($('.js-product-characteristics-select')).each(function (){
                let _this=$(this);
                var $parent = _this.closest(".sort");
                var $sortModalBody = $parent.find(".sort-modal__body");
                var $sortBtn = $parent.find(".sort-btn");
                _this.select2({width:"100%",minimumResultsForSearch:-1,templateResult: selectTemplateResult,templateSelection: selectTemplateSelection,dropdownParent: $sortModalBody});
                function selectTemplateSelection(opt) {
                    var result = "<div class=\"sort-product__characteristics__result\"><span class=\"sort-product__characteristics__result-placeholder\">" + _this.attr("data-placeholder") + "</span><span class=\"sort-product__characteristics__result-value\">" + opt.text + "</span></div>";
                    $sortBtn.html(result);
                    return $(result)
                }
                $(document).on("select2:close",_this, function (e) {
                    $parent.removeClass("active")
                });
                $(document).on("click",'.sort-btn', function (e) {
                    e.preventDefault();
                    $(this).closest(".sort").find($('.sort-block')).find($('.js-product-characteristics-select')).select2("open");
                    $(this).closest(".sort").addClass("active")
                })
                $(document).on("click",'.sort-modal__close', function (e) {
                    e.preventDefault();
                    $(this).closest(".sort").find($('.sort-block')).find($('.js-product-characteristics-select')).select2("close");
                })
            })
            function selectTemplateResult(opt) {
                if (!opt.id) {
                    return opt.text
                }
                var optImage = $(opt.element).data("img");
                if (!optImage) {
                    var $opt = $("<div class=\"select2-results__option-custom \">\n\t\t\t\t\t\t<span>" + opt.text + "</span>\n\t\t\t\t\t</div>");
                    return $opt
                } else {
                    var _$opt = $("<div class=\"select2-results__option-custom select2-results__option__multi-img\">\n\t\t\t\t\t<img src=\"" + optImage + "\" />\n\t\t\t\t\t<span>" + $(opt.element).text() + "</span>\n\t\t\t\t</div>");
                    return _$opt
                }
            }
        });
        updateMedia(getCurentVariantForFirstOption());
    });
    function getCurentVariant() {
        let variantData = JSON.parse($('variant-selects').find($('[type="application/json"]'))[0].textContent);
        let options =  Array.from($(`variant-selects select.js-product-characteristics-select`), select => select.value)
        let curentVariant = variantData.find((variant) => {
            return !variant.options.map((option, index) => {
                return options[index] === option;
            }).includes(false);
        })
        return curentVariant;
    }
    function getCurentVariantForFirstOption() {
        let variantData = JSON.parse($('variant-selects').find($('[type="application/json"]'))[0].textContent);
        let options =  $(`variant-selects select.js-product-characteristics-select.js-first-option`).val()
        let curentVariant = variantData.find(variant => variant.option1 == options)
        return curentVariant;
    }
    function updateMedia(variant) {
        if (!variant || !variant.featured_image) return;
        let variant_image= variant.featured_image.id;
        let slider_image = $('.product-view__slider .js-product-view-img-slider .slick-slide:not(.slick-cloned)').find($(`[data-media-id="${variant_image}"]`)).closest('.slick-slide').attr('data-slick-index');
        $('.js-product-view-img-slider').slick('slickGoTo', slider_image);
    }

})
$(document).on("click", ".product-view .js-counter-popup .counter-item:not(.counter-number)" , function () {
    let _this = $(this)
    setTimeout(function () {
        let quantity =parseInt(_this.closest(".js-counter").attr("data-available"))
        let inventory =_this.closest(".js-counter").attr("data-inventory")
        let value = parseInt(_this.closest(".js-counter").find($('.counter-number'))[0].value);
        let popup = _this.closest(".js-counter").find($('.info-popup'));
        if(value > quantity && inventory == "continue" && quantity != 0){
            let difference = value - quantity
            popup.find($('.text'))[0].innerHTML= quantity+ " items are in stock, "+difference+" backordered in main stock"
            _this.closest(".js-counter").addClass("info-popup-open")
        }
        if(value > quantity && inventory == "deny"){
            popup.find($('.text'))[0].innerHTML= quantity+" items are available for order"
            _this.closest(".js-counter").addClass("info-popup-open")
        }
    }, 300)
});
$(document).on("change",".product-view .js-counter-popup .counter-number", function () {
    let _this = $(this)
    let quantity =  parseInt(_this.closest(".js-counter").attr("data-available"))
    let inventory =_this.closest(".js-counter").attr("data-inventory")
    let value =  parseInt(_this[0].value);
    let popup = _this.closest(".js-counter").find($('.info-popup'));
    if(value > quantity && inventory == "continue" && quantity != 0){
        let difference = value - quantity
        popup.find($('.text'))[0].innerHTML= quantity+ " items are in stock, "+difference+" backordered in main stock"
        _this.closest(".js-counter").addClass("info-popup-open")
    }
    if(value > quantity && inventory == "deny"){
        popup.find($('.text'))[0].innerHTML= quantity+" items are available for order"
        _this.closest(".js-counter").addClass("info-popup-open")
    }

});
$(document).on("change",'.product-view .main-product__status-switch-btn input', function () {
    if ($(this).is(':checked')) {
        $('.product-view').find($('product-form .btn')).removeAttr("disabled");
    } else {
        $('.product-view').find($('product-form .btn')).prop("disabled", "disabled")
    }
})